<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
      Users List
    </v-card-title> -->
    <v-card-title>
      
        <v-btn
              v-if="role.create"
              color="primary"
              dark
              class="mb-2"
              @click="addData"
            >
              Add User
            </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      fixed-header
      loading-text="Loading... Please wait"
      ref="vTable"
      :height="tableProps.tableHeight"
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >
     <template v-slot:[`item.role`]="{ item }">
        {{ role_name(item.role_name).toString() }}
      </template>
      <template  v-slot:[`item.pool`]="{ item }">
        <span v-if="item.pool!=null">{{ item.pool.pool_name }}</span>
      </template>
     <template v-slot:[`item.active`]="{ item }">
        <!-- {{ item.active }} -->
        <span v-if="item.active == 1">Active</span>
        <span v-else>Not Active</span>
    </template>
     <template v-slot:[`item.actions`]="{ item }">
      <!-- <v-icon
        small
        class="mr-2"
        @click="editData(item.id)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteData(item.id)"
      >
        mdi-delete
      </v-icon> -->
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="role.update" @click="editData(item.id)">
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role.update && item.id!=1" @click="updateStatusActive(item.id,item.active)">
            <v-list-item-title>
              <span v-if="item.active == 1" >Deactivate</span>
              <span v-else>Activate</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role.delete" @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import { ResizablePage } from "@/components";


  export default {
    vuetify,
    components: {ResizablePage},
    data () {
      return {
        loadTable: true,
        role: "",
        search: '',
        headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'name',
          },
          { text: 'Email', value: 'email' },
          { text: 'Roles', value: 'role' },
          { text: 'Active', value: 'active' },
          { text: 'Eshed', value: 'pool' },
          { text: 'Actions', value: 'actions',align: 'center', sortable: false, sortable: false },
        ],
        table: [],
      }
    },
    async created() {
      
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {

      await this.$store.dispatch("users/list");
      if (
        (await this.$store.getters["users/list"]) &&
        (await this.$store.getters["users/list"].length) != 0
      ) {
        this.table = await this.$store.getters["users/list"];
      }
      else{
        this.table = []
      }
      this.loadTable= false
    },

    role_name(data){
      console.log(data)
     return data.map(function (data) {
          return data.name;
      })
    },


    // fungsi tombol direct ke add page
    addData() {
      // panggil add page
      this.$router.push({ name: "Add Users" });
    },

    // fungsi tombol direct ke edit page
    editData(id) {
      // panggil edit page
      this.$router.push({ name: "Edit Users", params: { userId: id } });
    },

async updateStatusActive(id,status) {
    try {
        var notif_val = "User activated successfully."
        if(status == 1){
          notif_val = "User disabled successfully."
        }
        // kirim data ke api
        await this.$store.dispatch("users/change_status", id);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          notif_val
        );
        this.getList();
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
  },

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },
  
     // fungsi delete
    async deleteData(id) {
      try {
        // kirim data ke api
        await this.$store.dispatch("users/destroy", id);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "User data delete successfully."
        );
        //await this.getList();
        var indexOptionTable = this.table.findIndex(p => p.id ==  id)
           this.table.splice(indexOptionTable, 1)
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>